import React, { useContext } from 'react';

import './StoresInformation.scss';
import Icon from '../../UIElements/Icon/Icon';
import { LanguageContext } from '../../../context/language-context';

const StoresInformation = ({ className }) => {
  const lng = useContext(LanguageContext);
  const { language } = lng;

  return (
    <ul className={`stores-information ${className}`}>
      <li>
        <h4 className="stores-information__store-name">store 1</h4>
        <div className="stores-information__address">
          <Icon width={10} height={10} id="icon-location" />
          <p>1234 00th Avenue Santa Clara, CA, 95000</p>
        </div>
        <div className="stores-information__telephone">
          <Icon width={10} height={10} id="icon-phone" />
          <p>(000) 111-2222</p>
        </div>
        <div className="stores-information__email">
          <Icon width={10} height={10} id="icon-email" />
          <p>kento.takeuchi.official@gmail.com</p>
        </div>

        <div className="stores-information__open-time">
          <div>
            <span>
              <Icon width={10} height={10} id="icon-clock" />
              {language === 'en' ? 'Wednesday – Sunday' : '水 - 日'}
            </span>
          </div>
          <p>7:00am - 6:00pm</p>
        </div>
      </li>
      <li>
        <h4 className="stores-information__store-name">store 2</h4>
        <div className="stores-information__address">
          <Icon width={10} height={10} id="icon-location" />
          <p>9876 11th Avenue San Jose, CA 94000</p>
        </div>
        <div className="stores-information__telephone">
          <Icon width={10} height={10} id="icon-phone" />
          <p>(999) 888-7777</p>
        </div>
        <div className="stores-information__email">
          <Icon width={10} height={10} id="icon-email" />
          <p>kento.takeuchi.official@gmail.com</p>
        </div>
        <div className="stores-information__open-time">
          <div>
            <span>
              <Icon width={10} height={10} id="icon-clock" />
              {language === 'en' ? 'Wednesday – Sunday' : '水 - 日'}
            </span>
          </div>
          <p>11:30am - 8:00pm</p>
        </div>
      </li>
    </ul>
  );
};

export default StoresInformation;
